// extracted by mini-css-extract-plugin
export default {"separator":"Navbar_separator__jLr7m","languageList":"Navbar_languageList__SrIuK","dropDown":"Navbar_dropDown__-UeaY","lngIcon":"Navbar_lngIcon__9jKE6"};